import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["className", "filters", "innerClass", "renderResult", "noResults", "resultViews", "pageSizes", "sortOptions", "contentTypeName", "showOptions", "buttonColor", "filtersSize", "filtersAttrs", "resultsListAttrs"];
import React from 'react';
import classNames from 'classnames';
import { Row, Col, Button, Label } from 'reactstrap';
import { Result, NoResults } from '..';
import SelectBox from '../../Forms/SelectBox';
import { Results, Paging, PagingInfo, ResultsPerPage, Sorting, WithSearch } from '@elastic/react-search-ui';
import { kebabCase } from 'lodash';
import Pagination from 'react-js-pagination';
var blockClass = 'search-layout';

var wrapOption = function wrapOption(option) {
  return {
    label: option,
    value: option
  };
};

var SearchLayout = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchLayout, _React$Component);

  function SearchLayout(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "toggleOptions", function (openOptions) {
      _this.setState({
        isOptionsOpen: openOptions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFilters", function () {
      _this.setState({
        isFiltersOpen: !_this.state.isFiltersOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setView", function (i) {
      if (i !== _this.state.activeView) _this.setState({
        activeView: i
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (e) {
      if (_this.optionsMenu && _this.optionsMenu.contains(e.target)) {
        return;
      }

      _this.toggleOptions(false);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      document.addEventListener('mousedown', _this.handleDocumentClick, false);

      if (window.matchMedia('(min-width: 767px)').matches) {
        _this.setState({
          isMobile: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnMount", function () {
      document.removeEventListener('mousedown', _this.handleDocumentClick, false);
    });

    _this.state = {
      activeView: 0,
      isOptionsOpen: false,
      isFiltersOpen: false,
      isMobile: true
    };
    return _this;
  }

  var _proto = SearchLayout.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        filters = _this$props.filters,
        innerClass = _this$props.innerClass,
        renderResult = _this$props.renderResult,
        noResults = _this$props.noResults,
        resultViews = _this$props.resultViews,
        pageSizes = _this$props.pageSizes,
        sortOptions = _this$props.sortOptions,
        contentTypeName = _this$props.contentTypeName,
        showOptions = _this$props.showOptions,
        buttonColor = _this$props.buttonColor,
        filtersSize = _this$props.filtersSize,
        filtersAttrs = _this$props.filtersAttrs,
        resultsListAttrs = _this$props.resultsListAttrs,
        attrs = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var classes = classNames(blockClass, className);

    var renderSort = function renderSort(_ref) {
      var _onChange = _ref.onChange,
          options = _ref.options,
          value = _ref.value;
      var selectedValue = value;
      var selectedOption = selectedValue ? options.find(function (option) {
        return option.value === selectedValue;
      }) : null;
      return /*#__PURE__*/React.createElement(SelectBox, {
        className: blockClass + "__sort-options",
        value: selectedOption,
        onChange: function onChange(o) {
          return _onChange(o.value);
        },
        options: options,
        isSearchable: false,
        size: "sm"
      });
    };

    return /*#__PURE__*/React.createElement("section", _extends({
      className: classes
    }, attrs, {
      ref: function ref(el) {
        return _this2.searchLayout = el;
      }
    }), /*#__PURE__*/React.createElement(Results, {
      view: function view(_ref2) {
        var children = _ref2.children;

        if (children && children.length > 0) {
          return /*#__PURE__*/React.createElement("div", {
            className: "row mh-100"
          }, filters && /*#__PURE__*/React.createElement(Col, _extends({
            className: blockClass + "__filters" + (_this2.state.isFiltersOpen ? " " + blockClass + "__filters--isOpen" : '')
          }, filtersAttrs), /*#__PURE__*/React.createElement(Button, {
            className: blockClass + "__close-btn d-lg-none",
            close: true,
            onClick: function onClick() {
              return _this2.toggleFilters();
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__filters-wrapper px-md-2 py-4 p-lg-0"
          }, filters, /*#__PURE__*/React.createElement("div", {
            className: "text-center d-lg-none mt-4"
          }, /*#__PURE__*/React.createElement(Button, {
            color: buttonColor,
            className: blockClass + "__apply-btn w-100",
            onClick: function onClick() {
              return _this2.toggleFilters();
            }
          }, "Apply Filters")))), /*#__PURE__*/React.createElement(Col, _extends({
            className: blockClass + "__results-list"
          }, resultsListAttrs), /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__header"
          }, /*#__PURE__*/React.createElement(PagingInfo, {
            view: function view(_ref3) {
              var start = _ref3.start,
                  end = _ref3.end,
                  totalResults = _ref3.totalResults;
              return /*#__PURE__*/React.createElement("div", {
                className: blockClass + "__paging-info"
              }, start, "-", end, " of ", totalResults, ' ', contentTypeName ? " " + contentTypeName.toLowerCase() : '');
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__controls d-flex ml-auto"
          }, filters && /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__control " + blockClass + "__control--filters d-lg-none mr-3"
          }, /*#__PURE__*/React.createElement(Button, {
            className: blockClass + "__icon",
            color: "",
            onClick: function onClick() {
              return _this2.toggleFilters();
            }
          }, /*#__PURE__*/React.createElement("svg", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
              fill: 'none'
            }
          }, /*#__PURE__*/React.createElement("polygon", {
            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
          })), /*#__PURE__*/React.createElement("small", {
            className: blockClass + "__icon__title"
          }, "Filters"))), /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__control " + blockClass + "__control--options position-relative " + (!showOptions ? 'd-lg-none' : ''),
            ref: function ref(el) {
              return _this2.optionsMenu = el;
            }
          }, /*#__PURE__*/React.createElement(Button, {
            className: blockClass + "__icon",
            color: "",
            onClick: function onClick() {
              return _this2.toggleOptions(!_this2.state.isOptionsOpen);
            }
          }, /*#__PURE__*/React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            style: {
              stroke: 'none'
            }
          }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
            d: "M1.75,7.75h6.6803589c0.3355713,1.2952271,1.5039063,2.2587891,2.9026489,2.2587891   S13.9000854,9.0452271,14.2356567,7.75H24.25C24.6640625,7.75,25,7.4140625,25,7s-0.3359375-0.75-0.75-0.75H14.2356567   c-0.3355713-1.2952271-1.5039063-2.2587891-2.9026489-2.2587891S8.7659302,4.9547729,8.4303589,6.25H1.75   C1.3359375,6.25,1,6.5859375,1,7S1.3359375,7.75,1.75,7.75z M11.3330078,5.4912109   c0.8320313,0,1.5087891,0.6767578,1.5087891,1.5087891s-0.6767578,1.5087891-1.5087891,1.5087891S9.8242188,7.8320313,9.8242188,7   S10.5009766,5.4912109,11.3330078,5.4912109z"
          }), /*#__PURE__*/React.createElement("path", {
            d: "M24.25,12.25h-1.6061401c-0.3355713-1.2952271-1.5039063-2.2587891-2.9026489-2.2587891   S17.1741333,10.9547729,16.838562,12.25H1.75C1.3359375,12.25,1,12.5859375,1,13s0.3359375,0.75,0.75,0.75h15.088562   c0.3355713,1.2952271,1.5039063,2.2587891,2.9026489,2.2587891s2.5670776-0.963562,2.9026489-2.2587891H24.25   c0.4140625,0,0.75-0.3359375,0.75-0.75S24.6640625,12.25,24.25,12.25z M19.7412109,14.5087891   c-0.8320313,0-1.5087891-0.6767578-1.5087891-1.5087891s0.6767578-1.5087891,1.5087891-1.5087891S21.25,12.1679688,21.25,13   S20.5732422,14.5087891,19.7412109,14.5087891z"
          }), /*#__PURE__*/React.createElement("path", {
            d: "M24.25,18.25H9.7181396c-0.3355103-1.2952271-1.5037842-2.2587891-2.9017334-2.2587891   c-1.3987427,0-2.5670776,0.963562-2.9026489,2.2587891H1.75C1.3359375,18.25,1,18.5859375,1,19s0.3359375,0.75,0.75,0.75h2.1637573   c0.3355713,1.2952271,1.5039063,2.2587891,2.9026489,2.2587891c1.3979492,0,2.5662231-0.963562,2.9017334-2.2587891H24.25   c0.4140625,0,0.75-0.3359375,0.75-0.75S24.6640625,18.25,24.25,18.25z M6.8164063,20.5087891   c-0.8320313,0-1.5087891-0.6767578-1.5087891-1.5087891s0.6767578-1.5087891,1.5087891-1.5087891   c0.8310547,0,1.5078125,0.6767578,1.5078125,1.5087891S7.6474609,20.5087891,6.8164063,20.5087891z"
          }))), /*#__PURE__*/React.createElement("small", {
            className: blockClass + "__icon__title"
          }, "Options")), /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__options-menu mt-1 px-3 py-0 " + (_this2.state.isOptionsOpen ? blockClass + "__options-menu--isOpen" : '')
          }, sortOptions && sortOptions.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "my-3"
          }, /*#__PURE__*/React.createElement(Label, {
            className: "mb-1"
          }, "Sort By:"), /*#__PURE__*/React.createElement(Sorting, {
            sortOptions: sortOptions,
            view: renderSort
          })), showOptions && pageSizes.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "my-3"
          }, /*#__PURE__*/React.createElement(Label, {
            className: "mb-1"
          }, "Page Size:"), /*#__PURE__*/React.createElement(ResultsPerPage, {
            options: pageSizes,
            view: function view(_ref4) {
              var _onChange2 = _ref4.onChange,
                  options = _ref4.options,
                  selectedValue = _ref4.value;
              var selectedOption = null;

              if (selectedValue) {
                selectedOption = wrapOption(selectedValue);
                if (!options.includes(selectedValue)) options = [selectedValue].concat(options);
              }

              return /*#__PURE__*/React.createElement(SelectBox, {
                className: blockClass + "__page-sizes",
                isSearchable: false,
                value: selectedOption,
                onChange: function onChange(o) {
                  return _onChange2(o.value);
                },
                options: options.map(wrapOption),
                size: "sm"
              });
            }
          })), showOptions && resultViews.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "my-3"
          }, /*#__PURE__*/React.createElement(Label, {
            className: "mb-1"
          }, "View:"), /*#__PURE__*/React.createElement("span", {
            className: blockClass + "__view-options"
          }, resultViews.map(function (view, i) {
            return /*#__PURE__*/React.createElement(Button, {
              className: blockClass + "__icon ml-2 " + (_this2.state.activeView === i ? blockClass + "__icon--active" : ''),
              key: i,
              color: "",
              onClick: function onClick() {
                return _this2.setView(i);
              }
            }, view.icon, view.title && /*#__PURE__*/React.createElement("small", {
              className: blockClass + "__icon__title"
            }, view.title));
          }))))), sortOptions && sortOptions.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "align-items-center " + (!showOptions ? 'd-none d-lg-flex' : 'd-none')
          }, /*#__PURE__*/React.createElement(Label, {
            className: "mb-0 mr-2"
          }, "Sort By:"), /*#__PURE__*/React.createElement(Sorting, {
            sortOptions: sortOptions,
            view: renderSort
          })))), /*#__PURE__*/React.createElement(Row, {
            className: blockClass + "__list " + blockClass + "__list--" + kebabCase(resultViews[_this2.state.activeView].title)
          }, children), /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__footer pt-4"
          }, /*#__PURE__*/React.createElement(Paging, {
            view: function view(_ref5) {
              var current = _ref5.current,
                  resultsPerPage = _ref5.resultsPerPage,
                  _onChange3 = _ref5.onChange,
                  totalPages = _ref5.totalPages;

              if (totalPages > 1) {
                var pageItemClass = 'page-item';
                var pageLinkClass = 'page-link';
                var jumpLinkClass = pageLinkClass + "--icon";
                return /*#__PURE__*/React.createElement(Pagination, {
                  activePage: current,
                  itemsCountPerPage: resultsPerPage,
                  totalItemsCount: totalPages * resultsPerPage,
                  pageRangeDisplayed: 5,
                  onChange: function onChange(pageNumber) {
                    _onChange3(pageNumber);

                    _this2.searchLayout.scrollIntoView({
                      behavior: 'smooth'
                    });
                  },
                  innerClass: blockClass + "__paging pagination justify-content-center mb-0",
                  itemClass: pageItemClass,
                  linkClass: pageLinkClass,
                  firstPageText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
                    "aria-hidden": "true"
                  }, "\xAB"), /*#__PURE__*/React.createElement("span", {
                    className: "sr-only"
                  }, "First")),
                  lastPageText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
                    "aria-hidden": "true"
                  }, "\xBB"), /*#__PURE__*/React.createElement("span", {
                    className: "sr-only"
                  }, "Last")),
                  prevPageText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
                    "aria-hidden": "true"
                  }, "\u2039"), /*#__PURE__*/React.createElement("span", {
                    className: "sr-only"
                  }, "Previous")),
                  nextPageText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
                    "aria-hidden": "true"
                  }, "\u203A"), /*#__PURE__*/React.createElement("span", {
                    className: "sr-only"
                  }, "Next")),
                  linkClassFirst: jumpLinkClass,
                  linkClassLast: jumpLinkClass,
                  linkClassNext: jumpLinkClass,
                  linkClassPrev: jumpLinkClass,
                  hideFirstLastPages: _this2.state.isMobile,
                  hideDisabled: true
                });
              }

              return null;
            }
          }))));
        }

        return /*#__PURE__*/React.createElement(WithSearch, {
          mapContextToProps: function mapContextToProps(_ref6) {
            var isLoading = _ref6.isLoading;
            return {
              isLoading: isLoading
            };
          }
        }, function (_ref7) {
          var isLoading = _ref7.isLoading;
          return !isLoading && /*#__PURE__*/React.createElement("div", {
            className: blockClass + "__no-results"
          }, noResults || /*#__PURE__*/React.createElement(NoResults, {
            contentType: contentTypeName
          }));
        });
      },
      resultView: renderResult
    }));
  };

  return SearchLayout;
}(React.Component);

export { SearchLayout as default };
SearchLayout.defaultProps = {
  contentTypeName: 'Results',
  pageSizes: [12, 24, 48, 96],
  filtersAttrs: {
    lg: 3
  },
  resultsListAttrs: {
    lg: 9
  },
  buttonColor: 'primary',
  showOptions: true,
  sortOptions: [{
    name: 'Best Match',
    value: '',
    direction: ''
  }, {
    name: 'Title (A-Z)',
    value: 'title',
    direction: 'asc'
  }, {
    name: 'Title (Z-A)',
    value: 'title',
    direction: 'desc'
  }],
  renderResult: function renderResult(_ref8) {
    var className = _ref8.className,
        result = _ref8.result,
        onClickLink = _ref8.onClickLink;
    return /*#__PURE__*/React.createElement(Result, {
      className: className,
      onClickLink: onClickLink,
      title: result.title.raw,
      image: result.image.raw,
      linkAttributes: {
        href: result.url.raw
      },
      body: result.body && result.body.snippet
    });
  },
  resultViews: [{
    title: 'Grid',
    icon: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "2 2 14 14",
      style: {
        stroke: 'none'
      }
    }, /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
    }))
  }, {
    title: 'List',
    icon: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "2 3 20 18",
      style: {
        stroke: 'none'
      }
    }, /*#__PURE__*/React.createElement("path", {
      opacity: ".87",
      fill: "none",
      d: "M0 0h24v24H0V0z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 14h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm0 5h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zM4 9h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm5 5h10c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm0 5h10c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zM8 6v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1z"
    }))
  }]
};